import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { getApiObjectList } from "../util/common";
var getCategoryFromList = function getCategoryFromList(category_name, categories) {
  try {
    if (!category_name || typeof category_name !== 'string' || category_name.length <= 0) {
      return category_name;
    }
    if (!categories || categories.length <= 0) return category_name;
    var selected_category = categories.find(function (e) {
      return category_name === e.value;
    });
    if (!selected_category) return category_name;
    return selected_category.label;
  } catch (e) {
    console.warn('exception on getStageFromList', e);
  }
  return category_name;
};
var CategoryName = function CategoryName(_ref) {
  var className = _ref.className,
    id = _ref.id,
    name = _ref.name,
    categories = _ref.categories,
    Component = _ref.component;
  return /*#__PURE__*/React.createElement(Component, {
    className: className,
    id: id
  }, getCategoryFromList(name, categories));
};
CategoryName.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired
  // component: PropTypes.string,
};
CategoryName.defaultProps = {
  className: undefined,
  id: undefined,
  categories: undefined,
  component: 'span'
};
export default getApiObjectList('requirement_categories', 'categories')(CategoryName);